<div
  *ngIf="loading"
  class="spinner-container"
  fxLayout="row"
  fxLayoutAlign="center center">
  <mat-spinner
    color="accent"
    [diameter]="diameter"></mat-spinner>
</div>
